export default (cpfParam) => {
  if (!cpfParam) {
    return false;
  }
  const cpf = cpfParam.replace(/[^\d]+/g, '');
  if (cpf === '' || cpf.length !== 11) return false;
  // Valida 1o digito
  let add = 0;
  for (let i = 0; i < 9; i += 1) {
    add += parseInt(cpf.charAt(i), 10) * (10 - i);
  }
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) {
    rev = 0;
  }
  if (rev !== parseInt(cpf.charAt(9), 10)) {
    return false;
  }
  // Valida 2o digito
  add = 0;
  for (let i = 0; i < 10; i += 1) {
    add += parseInt(cpf.charAt(i), 10) * (11 - i);
  }
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) {
    rev = 0;
  }
  if (rev !== parseInt(cpf.charAt(10), 10)) {
    return false;
  }
  return true;
};



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/validacoes.js